__turbopack_context__.v({
  "tooltipContent": "tooltip-module-scss-module__90PC9q__tooltipContent",
});
